import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'

export default {
  loginInfor () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'LoginInformation',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  loginInforChangePassword (data) {
    return new Promise((resolve, reject) => {
      Axios.put(
        'LoginInformation/change-password',
        data,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(msg.updateFail)
          }
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  loginInforChangeEmail (data) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'LoginInformation/change-email',
        data,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            if (response.data.header.resultCode === code.duplicateMail || response.data.header.resultCode === code.noChange) {
              reject(msg.duplicateMail)
            }
            reject(response.data.header.message)
          }
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  confirmChangeMail (token) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'LoginInformation/confirm-change-email',
        {token: token},
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.resultCode)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getAmazonInfo (data) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Amazon',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  postAmazonInfo (data) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Amazon',
        data,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            if (response.data.header.resultCode === code.amazonUpdateFail || response.data.header.resultCode === code.noRecordFound) {
              reject(msg.amazonUpdateFail)
            }
            reject(response.data.header.message)
          }
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getSellerInformation (params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'User',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          const {
            resultCode,
            message
          } = response.data.header
          if (resultCode !== code.success && resultCode !== code.noRecordFound) {
            reject(message)
          }
          resolve(response.data.recordList)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  updateSellerInformation (payload = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'User',
        payload,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(msg.updateFail)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getPaymentInfo () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Withdrawal/information',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  postPaymentInfo (payload) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'Withdrawal',
        payload,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            if (response.data.header.resultCode === code.noRecordFound) {
              reject(msg.nameInvalidErr)
            } else if (response.data.header.resultCode === code.emailOrPasswordWrong) {
              reject(msg.confirmErr)
            } else {
              reject(msg.updateFailPassword)
            }

            reject(response.data.header.message)
          }
          resolve(response.data.recordList)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  updateSetting (payload = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(
        'User/setting',
        payload,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(msg.updateFail)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getDepositCategory () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'Withdrawal/deposit-category',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.recordList)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getPaymentCycle () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'PaymentSchedule/information',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  updatePaymentCycle (data) {
    return new Promise((resolve, reject) => {
      Axios.put(
        '/PaymentSchedule/update',
        data,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(msg.updateFail)
          }
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  getExternalService (serviceId) {
    return new Promise((resolve, reject) => {
      Axios.get(
        'ExternalService/show',
        {service_id: serviceId},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          const {
            resultCode,
            message
          } = response.data.header
          if (resultCode !== code.success && resultCode !== code.noRecordFound) {
            reject(message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getPaymentMethod () {
    return new Promise((resolve, reject) => {
      Axios.get(
        'mbank_defaults',
        {},
        response => {
          if (!response || !response.data || !response.data.recordList) {
            reject(msg.serverErr)
          }
          const {
            resultCode,
            message
          } = response.data.header
          if (resultCode !== code.success && resultCode !== code.noRecordFound) {
            reject(message)
          }
          resolve(response.data.recordList)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/settingservice.js